import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-vendor',
  templateUrl: './create-vendor.component.html',
  styleUrls: ['./create-vendor.component.css']
})
export class CreateVendorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
